module.exports = __webpack_public_path__ + "media/wahoobay.8dc19ff5.mp4";